import { templatesConfig } from "../templateUtils";

function getTemplateContent(type) {
  return templatesConfig.templates[type].templateComponent;
}

export default getTemplateContent;
